import Component from '../../components/Component';
import Timeline from '../../components/Timeline';
import Loading from '../../components/Loading';

import query from './query';
import keys from './keys';

class Summary extends Component {
    constructor(props) {
        super();
        this.query = query({ page: props.page, domain: props.domain });
    }

    render() {
        if (this.state.loading) {
            return <Loading />;
        }

        return (
            <>
                <Timeline
                    data={this.state.data}
                    keys={keys}
                    header="Google Discover Data"
                    forceRun={this.forceRun}
                    content_id={this.props.content_id}
                    parent_id={this.props.parent_id}
                    hasRightAxis
                    rightAxisLabel="CTR (%)"
                    hasLeftSecondAxis
                    leftSecondAxisLabel="Clicks"
                    leftAxisLabel="Impressions"
                    customEmptyMessage={this.props.from_gsc ? 'Not found in Google Discover' : ''}
                    metricType="primary"
                />
                {this.state.data && this.state.data.length && (
                    <div className="redirect-button">
                        <a
                            className="button-close"
                            href="/domains/{{ domain.pk }}/pages/page/?page={{ url }}"
                        >
                            View Discover Data
                        </a>
                    </div>
                )}
            </>
        );
    }
}

export default Summary;
